module.exports = __webpack_public_path__ + "static/media/eminence-ikebukuro-3.bad16388.jpg";